export function twinRouteAccess({ routeTwinId, demoTwinId, session, viewTwins }) {
  if (!routeTwinId) return "map";
  if (demoTwinId && routeTwinId === demoTwinId) return "demo";
  if (session && [...(session.twins || []), ...(viewTwins || [])].some((twin) => twin.twinId === routeTwinId)) return "authenticated";
  return "public";
}
